<template>
	<div class="container-wrap rtr_activity">
		<div class="container-box">
			<div class="" v-if="mode === 'list'">
				<div class="card">
					<h3 class="title">
						<img
							:src="iconActivityDetailTitle"
							alt=""
							style="width: 24px; height: 24px"
						/>
						{{ $t('rtr_activity.title') }}
					</h3>
				</div>
				<div class="card pt_40">
					<div
						:class="[
							isMobile ? 'd_block' : 'd_flex',
							'align_items_end',
							'justify_between',
						]"
					>
						<div :class="[isMobile ? 'd_block' : 'd_flex', 'align_items_end']">
							<div
								:class="['d_flex', 'align_items_end', isMobile ? 'mb_10' : '']"
							>
								<div class="info mr_10">
									<p class="mb_10">{{ $t('rtr_activity.start') }}</p>
									<date-picker
										is-required
										v-model="startDate"
										:model-config="{ type: 'string' }"
										:locale="$store.state.common.locale"
									>
										<template v-slot="{ inputValue, inputEvents }">
											<label class="calendar_area">
												<input
													class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
													:value="inputValue"
													v-on="inputEvents"
												/>
											</label>
										</template>
									</date-picker>
								</div>
								<div class="info mr_10">
									<p class="mb_10">{{ $t('rtr_activity.end') }}</p>
									<date-picker
										is-required
										v-model="endDate"
										:model-config="{ type: 'string' }"
										:locale="$store.state.common.locale"
									>
										<template v-slot="{ inputValue, inputEvents }">
											<label class="calendar_area">
												<input
													class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
													:value="inputValue"
													v-on="inputEvents"
												/>
											</label>
										</template>
									</date-picker>
								</div>
							</div>
							<div :class="['select_area', isMobile ? '' : 'mr_10']">
								<select
									v-model="accountSeq"
									:class="['asset_area', isMobile ? 'w100' : '']"
									@change="loadListHandler('pageInit')"
								>
									<option :value="null">
										{{ $t('input.placeholder.all_assets') }}
									</option>
									<option
										v-for="item in accounts"
										:key="item.seq"
										:value="item.seq"
										:label="item.asset_title"
									/>
								</select>
								<span class="select_icon"></span>
							</div>
						</div>
						<button type="button" class="button_bg_blue" @click="excelDownload">
							<img
								:src="iconBtnState"
								alt=""
								class=""
								:style="
									isMobile
										? { width: '16px', height: '16px' }
										: { width: '20px', height: '20px' }
								"
							/>
							<span>{{ $t('rtr_activity.button1') }}</span>
						</button>
					</div>
					<ul class="tab_area">
						<li
							:class="[{ selected: selectedTab === 'account' }, 'buy']"
							@click="selectedTab = 'account'"
						>
							<a>{{ $t('rtr_activity.account') }}</a>
						</li>
						<li
							:class="[{ selected: selectedTab === 'address' }, 'buy']"
							@click="selectedTab = 'address'"
						>
							<a>{{ $t('rtr_activity.wallet') }}</a>
						</li>
					</ul>
					<div class="check_select">
						<div class="all_check_box" @click="checkboxHandler">
							<input
								class="list_input mr_10 checkbox"
								type="checkbox"
								v-model="isAllChecked"
							/>
							<p class="mb_0">{{ $t('rtr_activity.check_all') }}</p>
						</div>
						<div class="select_area" v-if="selectedTab === 'address'">
							<select v-model="addressType" class="asset_area">
								<option value="deposit">
									{{ $t('rtr_activity.deposit') }}
								</option>
								<option value="withdraw">
									{{ $t('rtr_activity.withdrawal') }}
								</option>
							</select>
							<span class="select_icon"></span>
						</div>
					</div>
					<div v-if="transferList.length === 0" class="list_none">
						<span class="ERRORGRAY"></span>
						<p>{{ $t('rtr_activity.empty') }}</p>
					</div>
					<div v-else class="list_wrap">
						<div class="list">
							<div v-if="selectedTab === 'account'">
								<div v-if="!isMobile" class="list_item_wrap">
									<div
										v-for="item in transferList"
										:key="item.seq"
										class="list_item"
									>
										<div class="list_item_box">
											<div @click.stop="" class="list_input">
												<input
													class="list_input mr_10 checkbox"
													type="checkbox"
													v-model="item.checked"
												/>
												<span class="list_num">{{ item._no }}</span>
											</div>
											<!-- 출금 -->
											<div
												class="list_item_box_center"
												v-if="
													item.from_user_name ===
													$store.state.auth.member_info.user_name
												"
											>
												<div class="item">
													<p>{{ $t('rtr_activity.recipient') }}</p>
													<p>{{ item.to_user_name }}</p>
													<p class="date">
														{{
															$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss')
														}}
													</p>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.text8') }}</p>
													<div class="asset_box mt_5">
														<span :class="[item.asset_code, 'small']"></span>
														<p class="coin ma_0">{{ item.asset_code }}</p>
														<p class="name ma_0">{{ item.asset_title }}</p>
													</div>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.text3') }}</p>
													<p>{{ item.amount }}</p>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.d_account') }}</p>
													<p>{{ item.to_account_number }}</p>
												</div>
											</div>
											<!-- 입금 -->
											<div class="list_item_box_center" v-else>
												<div class="item">
													<p>{{ $t('rtr_activity.sender') }}</p>
													<p>{{ item.to_user_name }}</p>
													<p class="date">
														{{
															$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss')
														}}
													</p>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.text5') }}</p>
													<div class="asset_box mt_5">
														<span :class="[item.asset_code, 'small']"></span>
														<p class="coin ma_0">{{ item.asset_code }}</p>
														<p class="name ma_0">{{ item.asset_title }}</p>
													</div>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.text6') }}</p>
													<p>{{ item.amount }}</p>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.w_account') }}</p>
													<p>{{ item.from_account_number }}</p>
												</div>
											</div>
											<div class="list activity_button_area">
												<div
													v-if="
														item.from_user_name ===
														$store.state.auth.member_info.user_name
													"
													class="send_receive"
												>
													<span class="send">
														{{ $t('rtr_activity.withdrawal') }}
													</span>
												</div>
												<div v-else class="send_receive">
													<span class="receive">
														{{ $t('rtr_activity.deposit') }}
													</span>
												</div>
												<button
													class="button_primary"
													@click="showDetail(item)"
												>
													{{ $t('button.detail') }}
												</button>
											</div>
										</div>
									</div>
								</div>
								<div v-if="isMobile" class="table_mobile">
									<div
										v-for="item in transferList"
										:key="item.seq"
										class="table_item_mobile"
									>
										<div class="list_item_mobile">
											<div class="cont">
												<div class="list_title_box">
													<div @click.stop="" class="list_input">
														<input
															class="list_input mr_10 checkbox"
															type="checkbox"
															v-model="item.checked"
														/>
														<span class="list_num">{{ item._no }}</span>
														<p class="date mb_0 ml_10">
															{{
																$dayjs(item.regdate).format(
																	'YYYY.MM.DD HH:mm:ss',
																)
															}}
														</p>
													</div>
													<div
														v-if="
															item.from_user_name ===
															$store.state.auth.member_info.user_name
														"
														class="send_receive"
													>
														<span class="send">
															{{ $t('rtr_activity.withdrawal') }}
														</span>
													</div>
													<div v-else class="send_receive">
														<span class="receive">
															{{ $t('rtr_activity.deposit') }}
														</span>
													</div>
												</div>
												<div class="list_info_box">
													<!-- 출금 -->
													<div
														class=""
														v-if="
															item.from_user_name ===
															$store.state.auth.member_info.user_name
														"
													>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.recipient') }}</p>
																<p>{{ item.to_user_name }}</p>
																<p class="date">
																	{{
																		$dayjs(item.regdate).format(
																			'YYYY.MM.DD HH:mm:ss',
																		)
																	}}
																</p>
															</div>
														</div>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.text8') }}</p>
																<div class="asset_box mt_5">
																	<span
																		:class="[item.asset_code, 'small']"
																	></span>
																	<p class="code ma_0">{{ item.asset_code }}</p>
																	<p class="name ma_0">
																		{{ item.asset_title }}
																	</p>
																</div>
															</div>
														</div>
													</div>
													<!-- 입금 -->
													<div class="" v-else>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.sender') }}</p>
																<p>{{ item.to_user_name }}</p>
																<p class="date">
																	{{
																		$dayjs(item.regdate).format(
																			'YYYY.MM.DD HH:mm:ss',
																		)
																	}}
																</p>
															</div>
														</div>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.text5') }}</p>
																<div class="asset_box mt_5">
																	<span
																		:class="[item.asset_code, 'small']"
																	></span>
																	<p class="code ma_0">{{ item.asset_code }}</p>
																	<p class="name ma_0">
																		{{ item.asset_title }}
																	</p>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="button_area">
													<button
														class="button_bg_blue"
														@click="showDetail(item)"
													>
														{{ $t('button.detail') }}
													</button>
												</div>
												<div class="button_more_area">
													<div class="line"></div>
													<button @click="toggleMoreContent(item.seq)">
														<img
															:src="isItemOpen(item.seq) ? moreClose : more"
															alt="more"
															style="width: 24px; height: 24px"
														/>
													</button>
												</div>
											</div>
											<div class="more_cont" v-if="isItemOpen(item.seq)">
												<div class="list_info_box">
													<!-- 출금 -->
													<div
														class=""
														v-if="
															item.from_user_name ===
															$store.state.auth.member_info.user_name
														"
													>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.text3') }}</p>
																<p>{{ item.amount }}</p>
															</div>
														</div>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.d_account') }}</p>
																<p>{{ item.to_account_number }}</p>
															</div>
														</div>
													</div>
													<!-- 입금 -->
													<div class="" v-else>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.text6') }}</p>
																<p>{{ item.amount }}</p>
															</div>
														</div>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.w_account') }}</p>
																<p>{{ item.from_account_number }}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="selectedTab === 'address'">
								<div v-if="!isMobile" class="list_item_wrap">
									<div
										v-for="item in transferList"
										:key="item.seq"
										class="list_item"
									>
										<div class="list_item_box">
											<div @click.stop="" class="list_input">
												<input
													class="list_input mr_10 checkbox"
													type="checkbox"
													v-model="item.checked"
												/>
												<span class="list_num">{{ item._no }}</span>
											</div>
											<!-- 출금 -->
											<div
												class="list_item_box_center type02"
												v-if="addressType === 'withdraw'"
											>
												<div class="item">
													<p>{{ $t('rtr_activity.text8') }}</p>
													<div class="asset_box mb_15">
														<span :class="[item.asset_code, 'small']"></span>
														<p class="coin ma_0">{{ item.asset_code }}</p>
														<p class="name ma_0">{{ item.asset_title }}</p>
													</div>
													<p class="date">
														{{
															$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss')
														}}
													</p>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.text3') }}</p>
													<p>{{ item.request_amount }}</p>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.d_address') }}</p>
													<p>{{ item.account_number }}</p>
												</div>
											</div>
											<!-- 입금 -->
											<div class="list_item_box_center type02" v-else>
												<div class="item">
													<p>{{ $t('rtr_activity.text5') }}</p>
													<div class="asset_box mb_15">
														<span :class="[item.asset_code, 'small']"></span>
														<p class="coin ma_0">{{ item.asset_code }}</p>
														<p class="name ma_0">{{ item.asset_title }}</p>
													</div>
													<p class="date">
														{{
															$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss')
														}}
													</p>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.text6') }}</p>
													<p>{{ item.request_amount }}</p>
												</div>
												<div class="item">
													<p>{{ $t('rtr_activity.w_account') }}</p>
													<p>{{ item.account_number }}</p>
												</div>
											</div>
											<button class="button_primary" @click="showDetail(item)">
												{{ $t('button.detail') }}
											</button>
										</div>
									</div>
								</div>
								<div v-if="isMobile" class="table_mobile">
									<div
										v-for="item in transferList"
										:key="item.seq"
										class="table_item_mobile"
									>
										<div class="list_item_mobile">
											<div class="cont">
												<div class="list_title_box">
													<div @click.stop="" class="list_input">
														<input
															class="list_input mr_10 checkbox"
															type="checkbox"
															v-model="item.checked"
														/>
														<span class="list_num">{{ item._no }}</span>
														<p class="date mb_0 ml_10">
															{{
																$dayjs(item.regdate).format(
																	'YYYY.MM.DD HH:mm:ss',
																)
															}}
														</p>
													</div>
												</div>
												<div class="list_info_box">
													<!-- 출금 -->
													<div class="" v-if="addressType === 'withdraw'">
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.text8') }}</p>
																<div class="asset_box mt_5">
																	<span
																		:class="[item.asset_code, 'small']"
																	></span>
																	<p class="code ma_0">{{ item.asset_code }}</p>
																	<p class="name ma_0">
																		{{ item.asset_title }}
																	</p>
																</div>
															</div>
														</div>
													</div>
													<!-- 입금 -->
													<div class="" v-else>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.text5') }}</p>
																<div class="asset_box mt_5">
																	<span
																		:class="[item.asset_code, 'small']"
																	></span>
																	<p class="code ma_0">{{ item.asset_code }}</p>
																	<p class="name ma_0">
																		{{ item.asset_title }}
																	</p>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="button_area">
													<button
														class="button_bg_blue"
														@click="showDetail(item)"
													>
														{{ $t('button.detail') }}
													</button>
												</div>
												<div class="button_more_area">
													<div class="line"></div>
													<button @click="toggleMoreContent(item.seq)">
														<img
															:src="isItemOpen(item.seq) ? moreClose : more"
															alt="more"
															style="width: 24px; height: 24px"
														/>
													</button>
												</div>
											</div>
											<div class="more_cont" v-if="isItemOpen(item.seq)">
												<div class="list_info_box">
													<!-- 출금 -->
													<div class="" v-if="addressType === 'withdraw'">
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.text3') }}</p>
																<p>{{ item.request_amount }}</p>
															</div>
														</div>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.d_address') }}</p>
																<p>{{ item.account_number }}</p>
															</div>
														</div>
													</div>
													<!-- 입금 -->
													<div class="" v-else>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.text6') }}</p>
																<p>{{ item.request_amount }}</p>
															</div>
														</div>
														<div class="item">
															<div>
																<p>{{ $t('rtr_activity.w_account') }}</p>
																<p>{{ item.account_number }}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<pagination
								:totalCount="pageNavigation.total_count"
								:totalPage="pageNavigation.total_page"
								:curPage="pageNavigation.cur_page"
								:point="pageNavigation.point"
								:firstPage="pageNavigation.first_page"
								:lastPage="pageNavigation.last_page"
								@change="pageChangeHandler"
							></pagination>
						</div>
					</div>
				</div>
			</div>
			<ActivityDetail
				v-if="mode === 'detail'"
				:activity-info="activityInfo"
				:transfer-type="selectedTab"
				:address-type="addressType"
				@back="this.mode = 'list'"
			></ActivityDetail>
		</div>
	</div>
</template>

<script>
import { fetchAccountTransferList } from '@/api/account';
import { commonError } from '@/common/dialog';
import { mapGetters } from 'vuex';
import { utils, writeFile } from 'xlsx';
import pagination from '@/components/Pagination';
import ActivityDetail from '@/components/User/Activity/ActivityDetail';
import { fetchDepositList } from '@/api/deposit';
import { fetchWithdrawList } from '@/api/withdraw';
import iconActivityDetailTitle from '@/assets/images/v2/icon/icon-activity-detail-title.svg';
import iconBtnState from '@/assets/images/v2/icon/icon-btn-state.svg';
import more from '@/assets/images/v2/icon/more.svg';
import moreClose from '@/assets/images/v2/icon/more-close.svg';

export default {
	name: 'Activity',
	components: { pagination, ActivityDetail },
	data() {
		return {
			isAllChecked: false,
			selectedTab: 'account',
			excelHeaders: {
				account: {
					type: this.$t('rtr_activity.type'),
					regdate: this.$t('rtr_activity.registration_date'),
					assetTitle: this.$t('rtr_activity.asset_name'),
					from: this.$t('rtr_activity.sender'),
					to: this.$t('rtr_activity.recipient'),
					fromAccountNumber: this.$t('rtr_activity.w_account'),
					toAccountNumber: this.$t('rtr_activity.d_account'),
					amount: this.$t('rtr_activity.amount'),
				},
				address_deposit: {
					type: this.$t('rtr_activity.type'),
					regdate: this.$t('rtr_activity.registration_date'),
					assetTitle: this.$t('rtr_activity.asset_name'),
					accountNumber: this.$t('rtr_activity.w_account'),
					amount: this.$t('rtr_activity.amount'),
				},
				address_withdraw: {
					type: this.$t('rtr_activity.type'),
					regdate: this.$t('rtr_activity.registration_date'),
					assetTitle: this.$t('rtr_activity.asset_name'),
					accountNumber: this.$t('rtr_activity.d_account'),
					amount: this.$t('rtr_activity.amount'),
				},
			},
			// accountTransferList: [],
			transferList: [],
			startDate: this.$dayjs(new Date()).add(-6, 'month').toDate(),
			endDate: new Date(),
			accountSeq: null,
			addressType: 'deposit',
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			mode: 'list',
			activityInfo: {},
			iconActivityDetailTitle,
			iconBtnState,
			isMobile: false,
			openedItems: [],
			more,
			moreClose,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		isListAllCheck() {
			let check = this.transferList.length > 0;
			this.transferList.forEach(item => {
				if (!item.checked) {
					check = false;
					return false;
				}
			});
			return check;
		},
	},
	created() {
		this.accountSeq = this.$route.query.account_seq || null;

		this.init();
		this.checkMobile();
	},
	mounted() {
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	watch: {
		isListAllCheck() {
			this.isAllChecked = this.isListAllCheck;
		},
		startDate() {
			this.loadListHandler('pageInit');
		},
		endDate() {
			this.loadListHandler('pageInit');
		},
		selectedTab() {
			// 탭 변경 시 기존 데이터 즉시 초기화
			this.transferList = [];
			this.addressType = 'deposit';
			this.loadListHandler('pageInit');
		},
		addressType() {
			// address type 변경 시 기존 데이터 즉시 초기화
			this.transferList = [];
			this.loadListHandler('pageInit');
		},
	},
	methods: {
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
		init() {
			this.loadListHandler();
		},
		toggleMoreContent(itemSeq) {
			const index = this.openedItems.indexOf(itemSeq);
			if (index > -1) {
				this.openedItems.splice(index, 1);
			} else {
				this.openedItems.push(itemSeq);
			}
		},
		isItemOpen(itemSeq) {
			return this.openedItems.includes(itemSeq);
		},
		loadListHandler(type) {
			if (type === 'pageInit') this.curPage = 1;
			if (this.selectedTab === 'account') {
				this.loadTransferList();
			} else if (this.selectedTab === 'address') {
				if (this.addressType === 'deposit') {
					this.loadDepositList();
				} else {
					this.loadWithdrawList();
				}
			}
		},
		async loadTransferList() {
			const params = {
				account_seq: this.accountSeq,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};

			const { data, page_navigation } = await fetchAccountTransferList(
				params,
			).catch(commonError);

			this.transferList = data;
			this.pageNavigation = page_navigation;
		},
		async loadDepositList() {
			const params = {
				account_seq: this.accountSeq,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};

			const { data, page_navigation } = await fetchDepositList(params).catch(
				commonError,
			);

			this.transferList = data;
			this.pageNavigation = page_navigation;
		},
		async loadWithdrawList() {
			const params = {
				account_seq: this.accountSeq,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};

			const { data, page_navigation } = await fetchWithdrawList(params).catch(
				commonError,
			);

			this.transferList = data;
			this.pageNavigation = page_navigation;
		},

		showDetail(info) {
			this.activityInfo = info;
			this.mode = 'detail';
		},

		checkboxHandler() {
			this.transferList.forEach(item => {
				item.checked = !this.isAllChecked;
			});
		},

		excelDownload() {
			const excelData = this.makeExcelData();
			if (!excelData) return;
			const dataWS = utils.json_to_sheet(excelData, {
				skipHeader: true,
			});
			const wb = utils.book_new();
			utils.book_append_sheet(wb, dataWS, 'ActivityList');
			writeFile(wb, 'ActivityList.xlsx');
		},
		makeExcelData() {
			const excelData =
				this.selectedTab === 'account'
					? [this.excelHeaders[this.selectedTab]]
					: [this.excelHeaders[this.selectedTab + '_' + this.addressType]];
			const checkedList = this.transferList.filter(item => {
				return item.checked === true;
			});

			if (checkedList.length === 0) {
				alert(this.$t('alert.transaction_check'));
				return false;
			}

			if (this.selectedTab === 'account') {
				checkedList.forEach(item => {
					const obj = {
						type:
							item.from_user_name ===
							this.$store.state.auth.member_info.user_name
								? this.$t('rtr_activity.withdrawal')
								: this.$t('rtr_activity.deposit'),
						regdate: this.$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss'),
						assetTitle: item.asset_code + ' ' + item.asset_title,
						from: item.from_user_name,
						to: item.to_user_name,
						fromAccountNumber: item.from_account_number,
						toAccountNumber: item.to_account_number,
						amount: item.amount,
					};
					excelData.push(obj);
				});
			} else {
				checkedList.forEach(item => {
					const obj = {
						type:
							this.addressType === 'deposit'
								? this.$t('rtr_activity.deposit')
								: this.$t('rtr_activity.withdrawal'),
						regdate: this.$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss'),
						assetTitle: item.asset_code + ' ' + item.asset_title,
						accountNumber: item.account_number,
						amount: item.request_amount,
					};
					excelData.push(obj);
				});
			}

			return excelData;
		},

		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadListHandler();
		},
	},
};
</script>
